import { globalActions } from '../../global-actions';

export const getActionTypes = (actionPrefix) => ({
  AUDIO_COMPLETED: `${actionPrefix}_AUDIO_COMPLETED`,
  AUDIO_ERROR: `${actionPrefix}_AUDIO_ERROR`,
  AUDIO_PAUSED: `${actionPrefix}_AUDIO_PAUSED`,
  AUDIO_STARTED: `${actionPrefix}_AUDIO_STARTED`,
  AUDIO_DURATION: `${actionPrefix}_AUDIO_DURATION`,
  AUDIO_PERCENTAGE: `${actionPrefix}_AUDIO_PERCENTAGE`,
});

export const getActions = (actionPrefix) => ({
  setAudioCompleted: () => {
    globalActions.next({
      type: getActionTypes(actionPrefix).AUDIO_COMPLETED,
    });
  },
  setAudioPaused: (paused) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).AUDIO_PAUSED,
      payload: { paused },
    });
  },
  setErrorAudio: () => {
    globalActions.next({
      type: getActionTypes(actionPrefix).AUDIO_ERROR,
    });
  },
  setAudioStarted: () => {
    globalActions.next({
      type: getActionTypes(actionPrefix).AUDIO_STARTED,
    });
  },
  showAudioDuration: (duration) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).AUDIO_DURATION,
      payload: { duration },
    });
  },
  setAudioPercentage: (percentage) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).AUDIO_PERCENTAGE,
      payload: { percentage },
    });
  },
});
